import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { PasswordStrengthInfoTypesClass } from 'src/app/common/modules/password-strength-info/password-strength-info-type-class';
import { PageSizeItem } from '@progress/kendo-angular-grid';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { AngularDeviceInformationService } from 'angular-device-information';
import { DateInputFormatPlaceholder } from '@progress/kendo-angular-dateinputs';
import { environment } from 'src/environments/environment';
import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
declare const bootstrap: any;
declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class Globals {
  constructor(
    private cookieService: CookieService,
    private deviceInfo: AngularDeviceInformationService
  ) { }

  // Stripe Key
  stripePk: string = environment.production
    ? 'pk_live_51SFfr3KEfKiF3F4lqcm0PiCVLLXK2js9YrTwTldwL6bR5EZ2geztual8Ehr9c3mRDvc8khXZOY9yGb2OzFABJcUv000IBFy3G7'
    : 'pk_test_51NR3mxGua2SjD0hdHuV8V43iuxQ9t3YrxvBT53y70DXSXiZRXdPCIPUHKqEYYMErGhP8lZ1qUWyNeGGIkLiYRLfD00i63NFrQw';

  stripeSk: string = environment.production
    ? 'sk_live_xxxxx'
    : 'sk_test_xxxxx';

  amChartsLicenseKey: string = 'AM5C236795548';

  googleCaptchaSiteKey: string = environment.CAPTCHA_SITE_KEY;

  //env
  baseAPIFolderUrl: string = environment.apiUrl;
  baseAPIUrl: string = environment.apiUrl + '/api';
  baseUrl: string = environment.baseUrl;
  psiUrl: string | null = environment.psiUrl || null;
  learnUponUrl: string | null = environment.learnUponUrl || null;

  imageUrl: string = environment.apiUrl + '/storage/';
  cookieDomainUrl: string = environment.cookieDomainUrl;
  env: string = environment.env;
  isProduction: boolean = environment.production;
  showCaptcha: boolean = environment.showCaptcha;

  //auth
  authData: any = this.cookieService.get(window.btoa('logged_in_user_info'))
    ? JSON.parse(
      window.atob(this.cookieService.get(window.btoa('logged_in_user_info')))
    )
    : null;

  userRole: number = this.authData ? this.authData.role_id : null;
  selectedFacility: { facility: facility; role: facility_role } = this.authData ? this.authData.facility_details : null;

  userCurrentRole: { slug: role_slugs; label: string } = this.cookieService.get(
    window.btoa('current_role')
  )
    ? JSON.parse(
      window.atob(this.cookieService.get(window.btoa('current_role')))
    )
    : null;

  public getUserRoleProperty(prop: string): any[] {
    return this.authData && Array.isArray(this.authData.roles)
      ? this.authData.roles.map((role: any) => role[prop])
      : [];
  }

  isLoggedIn: boolean =
    this.authData && this.cookieService.get('access_token') !== null
      ? true
      : false;

  isItAdmin: boolean =
    this.userCurrentRole && this.userCurrentRole.slug === 'it-admin';
  isAdmin: boolean =
    this.userCurrentRole && this.userCurrentRole.slug === 'admin';
  isCandidate: boolean =
    this.userCurrentRole && this.userCurrentRole.slug === 'candidate';
  isAuditor: boolean =
    this.userCurrentRole && this.userCurrentRole.slug === 'auditor';
  isCredentialManager: boolean =
    this.userCurrentRole && this.userCurrentRole.slug === 'credential-manager';
  isAccountant: boolean =
    this.userCurrentRole && this.userCurrentRole.slug === 'accountant';
  isFacility: boolean =
    this.userCurrentRole && this.userCurrentRole.slug === 'facility';

  showAdminPanelHeader = false;
  showAdminPanelSideBar = false;
  showAdminPanelFooter = false;
  showUserPanelHeader = false;
  showUserPanelFooter = false;
  showLoginFooter = false;

  impersonateId: string | null = JSON.parse(window.atob(this.cookieService.get(window.btoa('impersonate_id'))) || 'null');
  impersonateBy: string | null = JSON.parse(window.atob(this.cookieService.get(window.btoa('impersonate_by'))) || 'null');
  impersonateByLastPage: string | null = JSON.parse(window.atob(this.cookieService.get(window.btoa('impersonate_by_last_page'))) || 'null');

  //common
  isLoading: boolean = false;
  alertTimer: number = 2000;
  currentLink: string = '';
  currentLinkArr: string[] = [];
  baseRoute: string = '';
  isAuthRoute: boolean = true;
  showWelcomeNote: boolean = false;
  commentMaxLength: number = 500;

  defaultLmsImage: string = 'assets/images/books.png';

  //UI Links
  uiLinkCommonData: any = [];
  uiContentCommonData: any = [];
  instagramLink: string = '';
  facebookLink: string = '';
  twitterLink: string = '';
  westminsterInsuranceLink: string = '';
  supportMailLink: string = 'chcsupport@homeopathcertifcation.org';
  linkedinLink: string = '';
  recertificationHandbookLink: string = '';
  examHandbookLink: string = '';
  examScheduleLink: string = '';
  examResourcesLink: string = '';
  examFeedbackLink: string = '';
  retireFormLink: string = '';
  chcLink: string = '';
  donationLink: string = '';
  telephone: string = '';
  ethicsAsthestationContent: string = '';
  uploadDocumentContent: string = '';

  ddFilterLength: number = 7;
  gridSearchMaxLength: number = 100;

  // grid
  pageSizes: (PageSizeItem | number)[] = [
    5,
    10,
    20,
    50
  ];
  defaultPageSize: number = 5;
  defaultPageSkip: number = 0;
  paginationNumericButtons: number = 5;

  //Regular Expression
  // regexWithoutSpace = /^(?!\s*$).+/;
  regexWithoutSpace = /^[^\s]+$/;
  regexWithoutLeadingTrailingSpace =
    /^(?=(?:.*[A-Za-z0-9]){2,})[A-Za-z0-9\s.,:'"()\/&_\-–]{2,100}$/;
  regexWithoutLeadingTrailingSpaceNumber =
    /^[A-Za-z0-9\s.,:'"()\/&_\-–]{2,100}$/;
  regexEmail = /^(?!\s*$)[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
  regexUsername = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[^\s]{8,}$/;
  regexPhone = /^(?!\s)(?!\s*$)(?![-() ]*$)\+?[0-9\-() ]{7,14}$/;
  regexName = /^[a-zA-Z0-9'.-][a-zA-Z0-9 '.-]{1,250}$/;
  regexPassword = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[&@%!$#-])[^\s]{8,}$/;
  passwordStrength: PasswordStrengthInfoTypesClass = {
    minLength: 8,
    number: true,
    lowerCase: true,
    upperCase: true,
    specialCharacter: ['&', '@', '%', '!', '$', '#', '-'],
  };
  regexAddress = /^(?!\s)[a-zA-Z0-9 '.-]{2,100}$/;
  regexCity = /^(?!\s)[a-zA-Z0-9 -]{2,50}$/;
  regexUrl = /^(?!\s)(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-./?%&=]*)?$/;
  regexDocNumber = /^(?!\s)[a-zA-Z0-9]+$/;
  regexCommon = /^(?!\s)[a-zA-Z0-9 -]{2,250}$/;
  regexDiscount = /^(?!\s*$).+/;
  regexDiscountPattern = /^[A-Za-z0-9_\-()]{3,50}$/;
  regexDiscountAmount = /^\d+(\.\d{1,2})?$/;
  regexDiscountMaxCount = /^\d+(\.\d{1,2})?$/;

  maxAddressLength = 100;
  maxNameLength = 50;
  maxCityLength = 50;
  maxSupervisorTitleLength = 50;
  maxJobTitleLength = 100;
  maxStreetAddressLength = 250;
  maxProfilePhoneNumberLength = 14;
  maxHrsPrWeekLength = 168;
  maxCommonLength = 250;
  minLicenceNumber = 2;

  //TODO: Added this regex for expereience, veirfy if it is working fine
  urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-./?%&=]*)?$/i;
  zipCodeRegex = /^(?!\s)[A-Za-z0-9\s-]{3,20}$/;
  emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  supervisorPhonePattern = /^\+?[\d\s-]{7,15}$/;
  dateInputFormat = 'MM/dd/yyyy';
  dateTimeInputFormat = 'MM/dd/yyyy, HH:mm';
  profilePhonePattern = /^\d{8,14}$/;
  commonNumberLetterRegex = /^[a-zA-Z0-9]+$/;
  commonAlphaNumericPattern =
    /^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9.,&/()'\- ]{2,250}$/;
  cityRegex = /^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9.,&/()'\- ]{2,50}$/;

  dateFormatPlaceholder: DateInputFormatPlaceholder = {
    year: 'YYYY',
    month: 'MM',
    day: 'DD',
    hour: 'h',
    minute: 'm',
    second: 's',
  };

  otpConfig = {
    allowNumbersOnly: true,
    length: 6,
    inputClass: 'otp-input ',
    placeholder: '',
    disableAutoFocus: false,
  };

  allowedFileExt = [
    '.jpg',
    '.jpeg',
    '.png',
    '.doc',
    '.docx',
    '.pdf',
    '.JPG',
    '.JPEG',
    '.PNG',
    '.DOC',
    '.DOCX',
    '.PDF',
  ];
  allowedFileExtAcceptStr = this.allowedFileExt.join(',');
  allowedFileExtMsg =
    'Supported formats: jpg, jpeg, png, doc, docx and pdf. Maximum file size: 2 MB. Need help? Please compress your file (PDF or image) before uploading.';
  allowedImageExt = ['.jpg', '.jpeg', '.png'];
  allowedImageSize = 2 * 1024 * 1024; //2 MB
  allowedFileRestriction: FileRestrictions = {
    allowedExtensions: this.allowedFileExt,
    maxFileSize: 2 * 1024 * 1024,
  };
  fileSelectDropFilesHere = 'Drag and Drop or Select Here to Upload File';
  fileSelectSelect = 'Select File(s)';

  paymentKeyForUSInitApp: string = '458ae5eb-25fe-11ee-9c2d-0045e23b5660';
  paymentKeyForInternationalInitApp: string =
    '98b6253e-32d6-11ee-9053-db336d8a6c7e';
  paymentKeyForCertificationExamFee: string =
    '1d758d5f-4335-11ee-9053-db336d8a6c7e';
  paymentKeyForCertificationExamRetakeFee: string =
    '40bdd904-4335-11ee-9053-db336d8a6c7e';
  paymentKeyForRecertificationExamRetakeFee: string =
    'd72e6e8c-4335-11ee-9053-db336d8a6c7e';
  paymentKeyForRecertificationFee: string =
    'a04de6fd-2624-11ee-9c2d-0045e23b5660';
  paymentKeyForRecertificationGraceFee: string =
    '58530f77-587a-11ee-9053-db336d8a6c7e';
  paymentKeyForRecertificationLapsSameYearFee: string =
    '9bbe7ce8-587a-11ee-9053-db336d8a6c7e';
  paymentKeyForRecertificationLapsNextYearFee: string =
    'e535b47c-587a-11ee-9053-db336d8a6c7e';
  paymentKeyForRecertificationSecondLapsSameYearFee: string =
    'e535b47c-587a-11ee-9053-db336d8a6c7e';
  paymentKeyForRecertificationSecondLapsNextYearFee: string =
    '8740af3f-c8e1-4c93-bdaa-24ad2db3fdb6';

  passExamScore: number = 255;
  examScoreRange: string = '100-300*';
  examScoreRangeDesc: string =
    '* The CHC reports exam scores using a scale of 100 to 300. A scale score is a floating scale used to adjust for differences in difficulty among exam versions to ensure fairness and consistency.';
  // examHandbookLink: string = 'https://www.homeopathicdirectory.com/_files/ugd/a0b3d0_4f3cf500ecfa4f2a898a934dd7fabb17.pdf';
  // examResourcesLink: string = 'https://www.homeopathicdirectory.com/examresources';
  // scheduleExamLink: string = 'https://www.webassessor.com/chc/index.html';

  lastNotification: any = null;

  isDonationEnabled: boolean = true;
  // donationLink: string = 'https://checkout.square.site/merchant/2H2NVTA5ZJ11E/checkout/Y4OHDN4W6Z7SNMAKLC6TY23D';

  browserInfo = {
    user_id: this.authData ? this.authData.id : null,
    isMobile: this.deviceInfo.isMobile(),
    isTablet: this.deviceInfo.isTablet(),
    isDesktop: this.deviceInfo.isDesktop(),
    deviceType: this.deviceInfo.getDeviceType(),
    os: this.deviceInfo.getDeviceInfo().os,
    osVersion: this.deviceInfo.getDeviceInfo().osVersion,
    browser: this.deviceInfo.getDeviceInfo().browser,
    browserVersion: this.deviceInfo.getDeviceInfo().browserVersion,
    browserMajorVersion: this.deviceInfo.getDeviceInfo().browserMajorVersion,
    screenResolution: this.deviceInfo.getDeviceInfo().screen_resolution,
    cookies: this.deviceInfo.getDeviceInfo().cookies,
    userAgent: this.deviceInfo.getDeviceInfo().userAgent,
  };

  // chartcolor = [
  //   0x3067c1, 0x2c5fb1, 0x2856a2, 0x244e92, 0x204582, 0x1c3d72, 0x193563,
  //   0x152c53, 0x112443, 0x0d1c34, 0x091324, 0x050b14,
  // ];

  chartcolor = [
    0x3067c1, 0x2c5fb1, 0x2856a2, 0x244e92, 0x204582, 0x1c3d72, 0x193563,
    0x152c53, 0x112443, 0x0d1c34, 0x091324, 0x050b14, 0x3067c1, 0x2c5fb1, 0x2856a2, 0x244e92, 0x204582, 0x1c3d72, 0x193563,

  ];

  checkKeyValueInLinks(data: any, key: string) {
    let link = data.filter((item: any) => item.key === key);
    if (link.length > 0) {
      return link[0].value;
    } else {
      return null;
    }
  }

  debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  calculateTotalHours(
    fromDate: string | Date,
    toDate: string | Date,
    hoursPerWeek: number
  ): number {
    if (!fromDate || !toDate || !hoursPerWeek || hoursPerWeek <= 0) return 0;

    const normalize = (date: string | Date): Date => {
      const d = new Date(date);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const from = normalize(fromDate);
    const to = normalize(toDate);

    if (from > to) return 0;

    const oneDay = 24 * 60 * 60 * 1000;
    const totalDays = Math.floor((to.getTime() - from.getTime()) / oneDay) + 1;
    const totalWeeks = Math.floor(totalDays / 7);
    return totalWeeks * hoursPerWeek;
  }

  getAgeLabel(dob: Date): string | null {
    const today = new Date();
    const birthDate = new Date(dob);

    // Normalize to remove time portion for exact date comparison
    const isSameDate =
      birthDate.getFullYear() === today.getFullYear() &&
      birthDate.getMonth() === today.getMonth() &&
      birthDate.getDate() === today.getDate();

    if (isSameDate) return 'Age: Today';

    if (dob > today) return null;

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    if (years > 0) {
      return `Age: ${years} year${years > 1 ? 's' : ''}`;
    } else if (months > 0) {
      return `Age: ${months} month${months > 1 ? 's' : ''}`;
    } else if (days > 0) {
      return `Age: ${days} day${days > 1 ? 's' : ''}`;
    }

    return null;
  }

  //helper function for debugging all form errors
  //TODO : remove in prod env
  logFormErrors(formGroup: any, parentKey: string = '') {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      const fullKey = parentKey ? `${parentKey}.${key}` : key;

      if (control instanceof FormGroup) {
        this.logFormErrors(control, fullKey);
      } else if (control instanceof FormArray) {
        control.controls.forEach((ctrl: any, index: number) => {
          this.logFormErrors(ctrl, `${fullKey}[${index}]`);
        });
      } else if (control && control.invalid) {
        console.warn(`Error in ${fullKey}:`, control.errors);
      }
    });
  }
}

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: 'value is only whitespace' };
  };
}
export function trimmedNameValidator(): ValidatorFn {
  const pattern = /^[a-zA-Z0-9 '.-]{2,250}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || typeof value !== 'string') return null;

    const trimmed = value.trim();

    const isValid = pattern.test(trimmed);

    if (!isValid) {
      return {
        invalidNameFormat: `Must be 2–250 characters long and may only include letters, numbers, spaces, apostrophes ('), periods (.), and hyphens (-)`,
      };
    }

    return null;
  };
}

export function trimmedAlphaNumericValidator(
  minLength = 2,
  maxLength = 250
): ValidatorFn {
  const pattern = /^(?=.*[A-Za-z])[A-Za-z0-9.,&/()'\- ]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value == null || typeof value !== 'string') return null;

    const trimmed = value.trim();

    const isValidLength =
      trimmed.length >= minLength && trimmed.length <= maxLength;
    const isValidPattern = pattern.test(trimmed);

    if (!isValidLength || !isValidPattern) {
      return {
        invalidTrimmedAlphaNumeric: `Must be ${minLength}–${maxLength} characters, contain at least one letter, and only include letters, numbers, spaces, and . , & / ( ) ' -`,
      };
    }

    return null;
  };
}

export function streetAddressValidator(
  minLength = 2,
  maxLength = 250
): ValidatorFn {
  const pattern = /^[A-Za-z0-9.,&/()'#\- ]+$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || typeof value !== 'string') return null;

    const trimmed = value.trim();
    const isValidLength =
      trimmed.length >= minLength && trimmed.length <= maxLength;
    const isValidPattern = pattern.test(trimmed);

    if (!isValidLength || !isValidPattern) {
      return {
        invalidStreetAddress: `Must be ${minLength}–${maxLength} characters, and may only include letters, numbers, spaces, and the symbols . , & / ( ) ' - #`,
      };
    }

    return null;
  };
}

export type role_slugs =
  | 'it-admin'
  | 'admin'
  | 'candidate'
  | 'auditor'
  | 'credential-manager'
  | 'accountant'
  | 'facility';

export interface facility {
  id: string;
  name: string;
  email: string;
  ein_number: string;
}

export interface facility_role {
  id: number;
  label: string;
}

// filter-utils.ts
export class FilterUtils {
  static openFilter(event?: MouseEvent): void {
    event?.stopPropagation();
    const el = document.getElementById('offcanvasRight');

    if (el) bootstrap.Offcanvas.getOrCreateInstance(el).show();
  }

  static closeFilter(): void {
    const el = document.getElementById('offcanvasRight');
    if (el) bootstrap.Offcanvas.getOrCreateInstance(el).hide();
    document.body.addEventListener(
      'hidden.bs.offcanvas',
      () => {
        document
          .querySelectorAll('.k-animation-container')
          .forEach((el) => el.remove());
      },
      { once: true }
    );
  }

  static handleClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const offcanvasEl = document.getElementById('offcanvasRight');
    if (!offcanvasEl?.classList.contains('show')) return;
    const insideOffcanvas = target.closest('#offcanvasRight');
    const insideFilterBlock = target.closest('.filter_block');
    const insideKendo =
      target.closest('.k-animation-container') || target.closest('.k-link');
    if (!insideOffcanvas && !insideFilterBlock && !insideKendo) {
      this.closeFilter();
    }
  }
}
